import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';

export const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div style={styles.container}>
      <button
        style={{
          ...styles.button,
          ...(language === 'zh' ? styles.activeButton : {}),
        }}
        onClick={() => setLanguage('zh')}
      >
        中文
      </button>
      <button
        style={{
          ...styles.button,
          ...(language === 'en' ? styles.activeButton : {}),
        }}
        onClick={() => setLanguage('en')}
      >
        English
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    marginBottom: '16px',
  },
  button: {
    padding: '6px 16px',
    border: '1px solid #e8e8e8',
    borderRadius: '6px',
    background: '#fff',
    color: '#666',
    cursor: 'pointer',
    fontSize: '13px',
    transition: 'all 0.2s',
  },
  activeButton: {
    background: '#667eea',
    color: '#fff',
    borderColor: '#667eea',
  },
};
